import { useEffect, useState } from 'react';
import type { CatalogResponse } from '@nadoutong/contracts';
import { PLATFORM_BASE_URL } from '../config/endpoints.ts';

interface CatalogState {
  data: CatalogResponse | null;
  loading: boolean;
}

export function useCatalog(): CatalogState {
  const [state, setState] = useState<CatalogState>({ data: null, loading: true });

  useEffect(() => {
    fetch(`${PLATFORM_BASE_URL}/v1/catalog`)
      .then(async (res) => {
        if (!res.ok) throw new Error(`${res.status}`);
        const json = await res.json() as CatalogResponse;
        setState({ data: json, loading: false });
      })
      .catch(() => {
        setState({ data: null, loading: false });
      });
  }, []);

  return state;
}
